/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGrid3x3 = createReactComponent("grid-3x3", "IconGrid3x3", [
  ["path", { d: "M3 8h18", key: "svg-0" }],
  ["path", { d: "M3 16h18", key: "svg-1" }],
  ["path", { d: "M8 3v18", key: "svg-2" }],
  ["path", { d: "M16 3v18", key: "svg-3" }]
]);

export { IconGrid3x3 as default };
//# sourceMappingURL=IconGrid3x3.js.map
